import React from 'react'
import { ResponsiveContainer, RadarChart, PolarGrid, 
    PolarAngleAxis, Radar, PolarRadiusAxis } from 'recharts'

function RadarMetrics({data}) {
  return (
    <div className='px-4 bg-[#c40c5c] text-white '>
    <ResponsiveContainer width="100%" height={300}>
      <RadarChart outerRadius={70} data={data}>
  <PolarGrid />
  <PolarAngleAxis dataKey="user" />
  <PolarRadiusAxis angle={30} domain={[0, 1]} />
  <Radar name="Mike" dataKey="similarity_score" stroke="#f0edef" fill="#e73cd5" fillOpacity={0.6} />
    </RadarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default RadarMetrics
